var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M2 2.667A1.333 1.333 0 102 0a1.333 1.333 0 000 2.667zm0 6.666A1.333 1.333 0 102 12a1.333 1.333 0 000-2.667zm0-4.666a1.333 1.333 0 100 2.666 1.333 1.333 0 000-2.666z"}})}
var staticRenderFns = []

export { render, staticRenderFns }